import Text from '@deprecated-ui/common/Text';
import device from '@deprecated-ui/_style/device';
import color from '@deprecated-ui/_style/color';
import { Tooltip } from 'antd';
import styled, { css } from 'styled-components';

const NavbarWrapper = styled.div`
  background: ${color.light};
  margin-bottom: 20px;
  position: relative;
  width: 100%;
  &.my {
    width: 118px;
  }

  > .navbar-company {
    position: relative;

    &.my {
      a {
        background: white;
      }
    }

    > div:first-child {
      position: static;
      width: 100%;

      & > a {
        border-bottom: 1px solid ${color.gainsboro};
        flex: 1 0 auto;
        width: calc((100% - 45px) / 2);

        @media ${device.mobileS} {
          width: calc((100% - 45px) / 3);
        }

        @media ${device.mobileL} {
          width: calc((100% - 45px) / 4);
        }

        @media ${device.tablet} {
          width: calc((100% - 45px) / 6);
        }

        @media ${device.laptop} {
          width: calc((100% - 45px) / 8) !important;
        }
      }
    }

    > div:last-child {
      > div:first-child {
        border-right: none;
      }

      > div:last-child {
        border-right: 1px solid ${color.gainsboro};
        border-top: 1px solid ${color.gainsboro};
        padding: 0;
        right: -1px;
        z-index: 99;
      }
    }
  }
`;

const NavLink = styled(Text).attrs({
  align: 'center',
  as: 'a',
  height: '40px',
  padding: '0 12px',
})`
  color: ${color.highempahis} !important;
  cursor: pointer;
  text-transform: capitalize;

  ${
    // @ts-expect-error
    ({ isActive }) =>
      isActive &&
      css`
        background-color: ${color.aliceBlue};
        color: ${color.primary} !important;
      `
  }

  :hover {
    color: ${color.primary} !important;
  }

  .analyst-tooltip {
    max-width: none;
    z-index: 99;
  }

  .ant-tooltip-inner {
    align-items: center;
    background-color: ${color.primary};
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    font-size: 14px;
    justify-content: center;
    margin: 0;
    max-width: 350px;
    padding: 0;
  }

  .ant-tooltip-arrow {
    border-bottom-color: ${color.primary};
  }
`;

const TooltipLink = styled.a`
  align-items: center;
  color: ${color.light};
  display: flex;
  height: 34px;
  justify-content: center;
  padding: 8px 10px;
  text-decoration: none;
  text-transform: none;

  :hover {
    color: ${color.light};
  }
`;

const AnalystTooltip = styled(Tooltip)`
  .analyst-tooltip {
    max-width: none;
    z-index: 99;
  }

  .ant-tooltip-inner {
    align-items: center;
    background-color: ${color.primary};
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    font-size: 14px;
    justify-content: center;
    margin: 0;
    max-width: 350px;
    padding: 0;
  }

  .ant-tooltip-arrow {
    border-bottom-color: ${color.primary};
  }
`;

export { NavbarWrapper, NavLink, TooltipLink, AnalystTooltip };
